/* eslint-disable no-console */
// eslint-disable-next-line import-x/no-duplicates
import "@/atoms/sentry";
import "@/atoms/build-date";
import "@/atoms/filter-console-logs";
import "@/atoms/scan";
import "@/index.css";

import type { FusionAuthProviderConfig } from "@fusionauth/react-sdk";
import { FusionAuthProvider } from "@fusionauth/react-sdk";
import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";

import { AutoLogIn } from "@/atoms/auto-logIn";
import { loading } from "@/atoms/loading";
// eslint-disable-next-line import-x/no-duplicates
import { Sentry } from "@/atoms/sentry";

const App = lazy(() => import("./app"));

function jsonOrText(value: unknown) {
  const stringValue = String(value);
  try {
    return JSON.parse(stringValue);
  } catch {
    return stringValue;
  }
}

const fusionAuthConfig: FusionAuthProviderConfig = {
  serverUrl: window.origin,
  clientId: import.meta.env.FUSIONAUTH_CLIENT_ID,
  redirectUri: window.origin,
  shouldAutoFetchUserInfo: true,
  shouldAutoRefresh: true,
  onRedirect(state) {
    location.replace(location.origin + state);
  },
  onAutoRefreshFailure({ message, name, cause, stack }) {
    console.error("Auto refresh failed");
    const msg = jsonOrText(message);
    console.log({ msg, name, cause, stack });

    if (typeof msg === "object" && msg && "details" in msg) {
      console.log(jsonOrText(msg["details"]));
    }
    // TODO: show user notification: session expired, please log in again
  },
  scope: "openid email profile offline_access",
};

const root = createRoot(document.getElementById("app")!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler(),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

const content = (
  <FusionAuthProvider {...fusionAuthConfig}>
    <AutoLogIn>
      <Suspense fallback={loading}>
        <App />
      </Suspense>
    </AutoLogIn>
  </FusionAuthProvider>
);

root.render(
  import.meta.env.REACT_STRICT_MODE ? (
    <StrictMode children={content} />
  ) : (
    content
  ),
);
